import { useEffect, useMemo, useState } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useRecipeAreas, useRecipeCategories } from '@/hooks';

interface AdvancedFiltersProps {
  category?: string;
  area?: string;
  onApply: (filters: { category?: string; area?: string }) => void;
  onClear: () => void;
  disabled?: boolean;
  className?: string;
}

export function AdvancedFilters({
  category,
  area,
  onApply,
  onClear,
  disabled = false,
  className,
}: AdvancedFiltersProps) {
  const { data: categories = [], isLoading: loadingCategories } = useRecipeCategories();
  const { data: areas = [], isLoading: loadingAreas } = useRecipeAreas();

  const [selectedCategory, setSelectedCategory] = useState<string | undefined>(category);
  const [selectedArea, setSelectedArea] = useState<string | undefined>(area);

  useEffect(() => setSelectedCategory(category), [category]);
  useEffect(() => setSelectedArea(area), [area]);

  const isLoading = loadingCategories || loadingAreas;

  const canApply = useMemo(() => {
    return (
      selectedCategory !== category ||
      selectedArea !== area
    );
  }, [selectedCategory, selectedArea, category, area]);

  const handleApply = () => {
    onApply({
      category: selectedCategory || undefined,
      area: selectedArea || undefined,
    });
  };

  const handleClear = () => {
    setSelectedCategory(undefined);
    setSelectedArea(undefined);
    onClear();
  };

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {/* Category */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Categoría</label>
          <select
            value={selectedCategory || ''}
            onChange={(e) => setSelectedCategory(e.target.value || undefined)}
            disabled={disabled || isLoading}
            className="w-full border rounded-md px-3 py-2 text-sm"
          >
            <option value="">Todas</option>
            {categories.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        {/* Area */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Área</label>
          <select
            value={selectedArea || ''}
            onChange={(e) => setSelectedArea(e.target.value || undefined)}
            disabled={disabled || isLoading}
            className="w-full border rounded-md px-3 py-2 text-sm"
          >
            <option value="">Todas</option>
            {areas.map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </select>
        </div>

        
      </div>

      <div className="flex items-center justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={handleClear}
          disabled={disabled || isLoading}
        >
          Limpiar
        </Button>
        <Button
          type="button"
          size="sm"
          onClick={handleApply}
          disabled={disabled || isLoading || !canApply}
        >
          Aplicar
        </Button>
      </div>
    </div>
  );
}


